<template>
  <GeneralDialog @on-close="onCloseModal" class="tw-w-[450px] tw-max-w-full">
    <template #body>
      <div
        class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4"
      >
        <div
          class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-8 tw-w-full"
        >
          <v-icon
            class="!tw-text-[50px]"
            icon="mdi-alpha-x-circle"
            color="#F45454"
          />
          <Text variant="h4" textAlign="center"
            >Are you sure you want to reject invitation?</Text
          >
        </div>
      </div>
    </template>
    <template #footer>
      <div class="tw-w-full tw-grid tw-grid-cols-2 tw-items-center tw-gap-3">
        <Button
          variant="secondary"
          :disabled="loading"
          label="Cancel"
          :isActive="true"
          @click="onCloseModal"
        />
        <Button
          :disabled="loading"
          :isLoading="loading"
          label="Reject"
          :isActive="true"
          @click="onReject"
        />
      </div>
    </template>
  </GeneralDialog>
</template>
<script setup>
import { computed, ref, reactive, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import Button from "@/core/components/ui/general/Button.vue";
import Text from "@/core/components/ui/general/Text.vue";
import TrashIcon from "@/core/components/icons/TrashIcon.vue";

const props = defineProps(["loading"]);
const emits = defineEmits(["on-close", "on-success", "on-delete"]);

const store = useStore();
const route = useRoute();

const state = reactive({
  loading: false,
});

const onCloseModal = () => {
  emits("on-close");
};

const onReject = () => {
  emits("on-reject");
};
</script>
